import { useEffect } from 'react';
import type { PlayerIndex } from '@tpubg/shared';
import { setCpuLabels } from './players';

/**
 * Names the computer's seat "Bot" while a vs-computer game is on screen.
 * Applied during render (so the very first frame is right) and undone on unmount.
 */
export function useCpuLabels(cpuPlayer: PlayerIndex | null): void {
  setCpuLabels(cpuPlayer);
  useEffect(() => {
    setCpuLabels(cpuPlayer);
    return () => setCpuLabels(null);
  }, [cpuPlayer]);
}
